import { ReactElement, ReactNode } from 'react'

import FormControl, { FormControlProps } from 'app/components/base/FormControl'
import Switch, { SwitchProps } from 'app/components/base/Switch'
import useFormField, { UseFormFieldProps } from 'app/hooks/useFormField'
import { combineControllerProps } from 'app/utils/helpers/form.helpers'

export interface SwitchFieldCustomProps extends UseFormFieldProps {
  helperText?: ReactElement | ReactNode | null
  formControlProps?: FormControlProps
}

export type SwitchFieldProps = SwitchFieldCustomProps & SwitchProps

const SwitchField = ({
  helperText,
  label,
  formControlProps,
  ...props
}: SwitchFieldProps) => {
  const { controllerProps, ...rest } = combineControllerProps(props)
  const { field, error, onChange, value } = useFormField(controllerProps)

  return (
    <FormControl
      errorMessage={error}
      helperText={helperText}
      {...formControlProps}
    >
      <Switch
        {...field}
        label={label}
        checked={!!value}
        onChange={onChange}
        {...rest}
      />
    </FormControl>
  )
}

export default SwitchField
